import Lottie from "react-lottie";
import animationData from "../../assets/lotties/loadingIcon.json";

export default function LoadingScreen() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        },
    };

    return (
        <div
            style={{
                position: `absolute`,
                backgroundColor: `white`,
                width: `100vw`,
                height: `100vh`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                zIndex: 100,
            }}
        >
            <Lottie options={defaultOptions} height={400} width={400} />
        </div>
    );
}
